export default __webpack_public_path__ + "static/media/galaxies.6eacfdcb.png";